import React, { useEffect, useMemo } from "react";
import CustomTable, { Column } from "../../../components/CustomTable";
// import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "react-router-dom";
import { useManageClientContext } from "../../../context/ManageClientContex";
import { getclientlistResponseModel } from "../../../model/clientmodel";
import moment from "moment";
import { useLoading } from "../../../context/LoadingContext";

const ManageClient: React.FC = () => {
  const navigate = useNavigate();
  const { isLoading } = useLoading();
  const { clientList, getClientlist, setClientFormType, setClientID } = useManageClientContext();
  const [searchName, setSearchName] = React.useState<string>("");
  const [statusValueData, setStateValueData] = React.useState<string>("1");

  const clientListData = useMemo(() => {
    return clientList
      ? clientList
          .filter((list) => list["client name"].toLowerCase().includes(searchName.toLowerCase()))
          .map((item) => {
            return {
              ...item,
              status: item.status ? "Active" : "InActive",
              "engagement start date": moment(item["engagement start date"]).isValid()
                ? moment(item["engagement start date"]).format("DD/MM/YYYY")
                : null,
            };
          })
      : null;
  }, [clientList, searchName]);

  const columns: Column<getclientlistResponseModel>[] = [
    { header: "Client Name", key: "client name", enableLink: true, path: "/client/updateclient" },
    {
      header: "Engagement Start Date",
      key: "engagement start date",
      enableLink: false,
      path: "",
    },
    {
      header: "Client Contact Number",
      key: "client contact name",
      enableLink: false,
      path: "",
    },
    { header: "Sales Contact Number", key: "sales contact name", enableLink: false, path: "" },
    { header: "Account Manager", key: "accoutn manager", enableLink: false, path: "" },
    { header: "Status", key: "status", enableLink: false, path: "" },
  ];

  useEffect(() => {
    getClientlist(statusValueData);
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // const refreshTable = () => {
  //   setStateValueData("0");
  //   getClientlist("1");
  //   setSearchName("");
  // };

  const handleNavigation = async (path: string | undefined, id: number) => {
    setClientFormType("update");
    setClientID(id);

    navigate(path ?? "", { state: { id: id } }); // Navigate to the specified path with state
  };

  return (
    <CustomTable
      showFilter={false}
      columns={columns}
      idKeyName='id'
      data={clientListData ?? []}
      handleNavigation={handleNavigation}
    >
      <button
        onClick={() => {
          setClientFormType("create");
          navigate("/client/createclient");
        }}
        className='flex items-center px-4 py-2 text-sm mb-3 bg-gray-900 text-white rounded-lg focus:outline-none hover:bg-gray-600'
      >
        Add New Client
      </button>
      <div className='max-w-4xl gap-x-6 gap-y-8 grid gap-3 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 '>
        <div>
          <label
            htmlFor='status'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-gray-400'
          >
            Search By Client Name
          </label>
          <div className='mt-2'>
            <input
              type='text'
              placeholder=''
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            />
          </div>
        </div>
        <div>
          <label
            htmlFor='status'
            className='block text-sm font-medium leading-6 text-gray-900 dark:text-white'
          >
            Status
          </label>
          <div className='mt-2'>
            <select
              id='status'
              value={statusValueData}
              onChange={(e) => {
                setStateValueData(e.target.value);
                getClientlist(e.target.value);
              }}
              className='shadow-sm bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 dark:shadow-sm-light'
            >
              <option value='1'>Active</option>
              <option value='0'>InActive</option>
            </select>
          </div>
        </div>
        {/* <div className='flex space-x-4'> */}
          {/* <button
            onClick={() => handleTableRefresh()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <MagnifyingGlassIcon className='h-5 w-5 text-white' />
          </button> */}
          {/* <button
            onClick={() => refreshTable()}
            className='flex  items-center px-4 py-2 mt-9 text-sm bg-blue-700 hover:bg-blue-800 text-white rounded-lg focus:outline-none '
          >
            <ArrowPathIcon className='h-5 w-5 text-white' />
          </button> */}
        {/* </div> */}
      </div>
    </CustomTable>
  );
};

export default ManageClient;
